
import React from "react";

export function DashboardHeader() {
  return (
    <div className="text-center space-y-4 max-w-3xl mx-auto">
      <h1 className="text-4xl font-bold tracking-tight">
        <span className="text-gray-900">Turnles</span>
        <span className="text-[#1b9d3d]"> Planner</span>
      </h1>
      <p className="text-lg text-gray-900">
        Maak en beheer je lesvoorbereidingen eenvoudig en professioneel
      </p>
    </div>
  );
}
